import { faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import routes from 'src/utils/routes';
import { getRouteURI } from 'src/utils/url';
import { getUuid } from 'src/utils/url';

const ViewShipmentListButton = ({ shipmentUri }) => {
  if (!shipmentUri) return null;

  return (
    <Link
      to={getRouteURI(routes.shipment, {
        uuid: getUuid(shipmentUri),
      })}
    >
      <button
        type='button'
        className='piece-overview-action-button piece-overview-action-button--run'
      >
        <FontAwesomeIcon icon={faList} className='piece-overview-action-button__icon' />
        View List
      </button>
    </Link>
  );
};

ViewShipmentListButton.propTypes = {
  shipmentUri: PropTypes.oneOfType([PropTypes.object.isRequired, PropTypes.string.isRequired]),
};

export default ViewShipmentListButton;
